<section>
  <div class="header d-flex d-md-block mb-0">
    <h1 class="d-block d-md-inline-block">{{ 'HELP_PAGE.HEADER' | translate }}</h1>
  </div>
  <div class="help_container">
    <div class="row">
      <div class="col-12">
        <div class="text-content">
          <h5 class="mb-3">{{ 'HELP_PAGE.NEWS_HEADLINE' | translate }}</h5>
          <app-information-block [text]="'HELP_PAGE.NEWS_TEXT' | translate"></app-information-block>
          <button class="btn btn-outlined info-btn" (click)="dhNews()">
            <img src="assets/icons/news-bell.svg" imageAlt="news" />{{ 'HELP_PAGE.NEWS_BTN' | translate }}
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="text-content">
          <h5 class="mb-3">{{ 'HELP_PAGE.USER_MANUAL_HEADLINE' | translate }}</h5>
          <app-information-block [text]="'HELP_PAGE.USER_MANUAL_TEXT' | translate"></app-information-block>
          <div class="flex-gap-12">
            <button class="btn btn-primary info-btn" (click)="dhQAndA()">
              <img src="assets/icons/question-mark-white.svg" imageAlt="user manual" />{{ 'HELP_PAGE.Q_AND_A_BTN' | translate }}
            </button>
            <button class="btn btn-primary info-btn" (click)="dhUserManual()">
              <img src="assets/icons/question-mark-white.svg" imageAlt="user manual" />{{ 'HELP_PAGE.USER_MANUAL_BTN' | translate }}
            </button>
            <button class="btn btn-primary info-btn" (click)="dhElearning()">
              <img src="assets/icons/question-mark-white.svg" imageAlt="user manual" />{{ 'HELP_PAGE.ELEARNING_BTN' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="text-content">
          <h5 class="mb-3">{{ 'HELP_PAGE.ASK_US' | translate }}</h5>
          <div class="input-text col-12 col-sm-12 col-md-12 col-lg-12">
            <app-text-area
              [control]="form.controls['message']"
              [helpText]="'SUPPORT.HELP_TEXT.MAIL'"
              autofocus
              tabIndex="0"
            ></app-text-area>
          </div>
          <button class="btn btn-outlined" (click)="sendMail()" [disabled]="isSendButtonDisabled">
            @if (isSendingEmail) {
              <span class="spinner"></span>
            }
            <img src="assets/icons/mail.svg" imageAlt="ask us" />{{ 'HELP_PAGE.MAIL_TO_SUPPORT_BTN' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="support_container">
    <div class="row">
      <div class="col-md-6 col-12">
        <div class="text-content mt-4">
          <h6>{{ 'HELP_PAGE.SUPPORT.CONTACT' | translate }}</h6>
          <a class="email" href="mailto:fastighetssupport@hogia.se">{{ 'HELP_PAGE.SUPPORT.EMAIL' | translate }}</a>
          <a [ngClass]="{ phone: true, 'not-clickable-phone': !this.isMobile }" href="tel:+4630368830">
            {{ 'HELP_PAGE.SUPPORT.PHONE' | translate }}
          </a>
          <p>{{ 'HELP_PAGE.SUPPORT.SCHEDULE' | translate }}</p>
          <p class="secondary-text">{{ 'HELP_PAGE.SUPPORT.LUNCHTIME' | translate }}</p>
          <p class="secondary-text">{{ 'HELP_PAGE.SUPPORT.HOLIDAYS_SCHEDULE' | translate }}</p>
          @if (licenseNumber) {
            <p class="secondary-text">{{ 'HELP_PAGE.SUPPORT.LICENSE_NUMBER' | translate: { value: licenseNumber } }}</p>
          }
        </div>
      </div>

      <div class="col-md-6 col-12 mb-3">
        <div class="text-content mt-4">
          <h6>{{ 'HELP_PAGE.SALES.CONTACT' | translate }}</h6>
          <a class="email" href="mailto:fastighetssystem@hogia.se">{{ 'HELP_PAGE.SALES.EMAIL' | translate }}</a>
          <a [ngClass]="{ phone: true, 'not-clickable-phone': !this.isMobile }" href="tel:+4630368820">
            {{ 'HELP_PAGE.SALES.PHONE' | translate }}
          </a>
          <p>{{ 'HELP_PAGE.SALES.SCHEDULE' | translate }}</p>
          <p class="secondary-text">{{ 'HELP_PAGE.SALES.LUNCHTIME' | translate }}</p>
          <p class="secondary-text">{{ 'HELP_PAGE.SALES.HOLIDAYS_SCHEDULE' | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</section>
